<template>
    <div class="bg-url">
        <div
            :class="{
                'container-calendar-venue': !mode,
                'container-event-mode': mode === 'eventsMode'
            }"
        >
            <div class="event-data">
                <span>SELECT EVENTS DATES</span>
            </div>
            <div class="registration-calendar">
                <div ref="calendar"></div>
            </div>
            <div class="selected-days" v-if="selectedDates.length">
                {{ selectedDates.length > 0 ? formatSelectedDates() : '' }} are selected as
                events dates
            </div>
            <button
                v-if="mode !== 'eventsMode'"
                @click="goToNextStep"
                class="next-step-budget-btn"
            >
                CONTINUE
            </button>
            <p v-if="mode !== 'eventsMode'" @click="goToPrevPage" class="back-step-budget-btn">
                Back
            </p>
        </div>
    </div>
</template>
<script>
    import { Calendar } from '@fullcalendar/core'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import multiMonthPlugin from '@fullcalendar/multimonth'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import listPlugin from '@fullcalendar/list'
    import interactionPlugin from '@fullcalendar/interaction'

    export default {
        name: 'CalendarPage',
        props: {
            mode: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selectedDates: [],
                allowDateClick: true
            }
        },
        methods: {
            dateSelect() {
                if (this.selectedDates.length === 3) {
                    this.allowDateClick = false
                }
            },
            updateAfterColor() {
                const today = new Date()
                const dayElements = document.querySelectorAll('.fc-daygrid-day')
                dayElements.forEach((dayElement) => {
                    const date = new Date(dayElement.getAttribute('data-date'))
                    if (date <= today) {
                        dayElement.classList.add('past-date')
                        dayElement.classList.remove('current-date')
                    } else if (date.toDateString() === today.toDateString()) {
                        dayElement.classList.remove('past-date')
                        dayElement.classList.add('current-date')
                    }
                })
            },
            handleDateSelect(info) {
                const clickedDate = info.dateStr
                const dateIndex = this.selectedDates.indexOf(clickedDate)
                if (dateIndex !== -1) {
                    this.selectedDates.splice(dateIndex, 1)
                }
                this.selectedDates.push(clickedDate)
                if (this.selectedDates.length > 3) {
                    this.selectedDates.shift()
                }
            },
            formatSelectedDates() {
                const options = { month: 'long', day: 'numeric', locale: 'en' }
                const selectedDatesLimited = this.selectedDates.slice(0, 3)
                return selectedDatesLimited
                    .map((date) => {
                        const dateObj = new Date(date)
                        if (isNaN(dateObj)) {
                            return ''
                        }
                        const formattedDate = dateObj.toLocaleDateString('en-En', options)
                        return formattedDate.replace(/^\w/, (c) => c.toUpperCase())
                    })
                    .join(' ')
            },
            goToNextStep() {
                let eventsDates = {
                    events_dates: this.selectedDates
                }
                this.$emit('next', eventsDates)
            },
            goToPrevPage() {
                this.$emit('prev')
            }
        },
        mounted() {
            const calendar = new Calendar(this.$refs.calendar, {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    multiMonthPlugin,
                    listPlugin,
                    interactionPlugin
                ],
                initialView: 'multiMonthFourMonth',
                dayMaxEvents: true,
                dayMaxEventRows: 1,
                editable: true,
                selectable: false,
                selectMirror: true,
                moreLinkClick: 'day',
                weekends: true,
                nowIndicator: true,
                select: this.handleDateSelect,
                longPressDelay: 1,
                eventClick: this.handleEventClick,
                datesSet: this.datesRender,
                contentHeight: 'auto',
                events: [],
                headerToolbar: {
                    start: 'prev',
                    center: '',
                    end: 'next'
                },
                views: {
                    multiMonthFourMonth: {
                        type: 'multiMonth',
                        duration: { months: 3 },
                        multiMonthTitleFormat: {
                            month: 'long',
                            year: 'numeric'
                        }
                    }
                },
                dateClick: (info) => {
                    if (!this.allowDateClick) {
                        return
                    }
                    const today = new Date()
                    const clickedDate = info.date
                    const selectedDateElements = document.querySelectorAll('.selected')
                    let isDateSelected = false
                    selectedDateElements.forEach((selectedDate) => {
                        if (selectedDate === info.dayEl) {
                            isDateSelected = true
                        }
                    })
                    if (isDateSelected) {
                        info.dayEl.style.backgroundColor = ''
                        info.dayEl.classList.remove('selected')
                        const index = this.selectedDates.indexOf(clickedDate.toISOString())
                        if (index > -1) {
                            this.selectedDates.splice(index, 1)
                        }
                    } else {
                        if (clickedDate <= today) {
                            return false
                        }
                        info.dayEl.style.backgroundColor = '#D7EB5A'
                        info.dayEl.classList.add('selected')
                        this.selectedDates.push(clickedDate.toISOString())
                    }
                }
            })
            calendar.render()
            this.updateAfterColor()
        }
    }
</script>
<style lang="scss">
    @import '../../../../../sass/_variables.scss';
    .registration-calendar .fc .fc-toolbar.fc-header-toolbar {
        margin-bottom: 0;
        position: relative;
        top: 45px;
        z-index: 2;
    }
    .registration-calendar .fc .fc-button-primary {
        background: none;
        border: none;
        color: #fff;
        position: relative;
    }
    .registration-calendar .fc .fc-multimonth {
        border: none;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: hidden;
        overflow-y: hidden;
        justify-content: space-between;
        flex-direction: row;
    }
    .registration-calendar .fc-multimonth-month {
        width: 30% !important;
    }
    .registration-calendar .fc .fc-daygrid-day.fc-day-today {
        background: #49306b;
        position: relative;
    }
    .registration-calendar .fc .fc-multimonth-singlecol .fc-multimonth-header {
        background: none;
        position: relative;
        top: 0;
        z-index: 0;
    }
    .registration-calendar .fc .fc-multimonth-multicol .fc-multimonth-month {
        box-shadow: 0px 13px 17px rgba(101, 100, 100, 0.15);
        border-radius: 8px;
    }
    .registration-calendar .fc .fc-multimonth-title {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.1em;
        color: #ffffff;
    }
    .registration-calendar .fc-theme-standard td,
    .fc-theme-standard th {
        border: none;
    }
    .registration-calendar .fc .fc-col-header-cell-cushion {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 13px;
        letter-spacing: 0.1em;
        color: #ffffff;
    }
    .registration-calendar .fc-col-header-cell-cushion[aria-label='Sunday'] {
        color: #c8dafd !important;
    }
    .registration-calendar .fc .fc-daygrid-day-number {
        padding: 0;
        z-index: 4;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .registration-calendar .fc .fc-daygrid-day-frame {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
    }
    .registration-calendar .fc .fc-multimonth-compact .fc-multimonth-daygrid-table {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 10.4856px;
        line-height: 13px;
        text-align: center;
        letter-spacing: 0.1em;
        color: #ffffff;
    }
    .registration-calendar tr {
        background: #000;
        padding-top: 0px;
    }
    .registration-calendar .fc .fc-highlight {
        background: none;
    }
    .registration-calendar .selected > div > div > a {
        color: black;
    }
    .registration-calendar .selected > div > div > a::after {
        color: #49306b;
    }
    .registration-calendar .selected-days {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 150%;
        color: #ffffff;
        margin-top: 50px;
    }
    .registration-calendar .fc-daygrid-day-number::after {
        content: '\00B7';
        color: #c8dafd;
        position: absolute;
        bottom: -10px;
        font-size: 22px;
    }
    .registration-calendar .fc-daygrid-day.past-date .fc-daygrid-day-number::after {
        content: '\00B7';
        color: gray;
    }
    .registration-calendar .fc-daygrid-day-number {
        color: #ffffff;
    }
    .registration-calendar .fc-theme-standard td,
    .fc-theme-standard th {
        padding: 16px;
    }
</style>

<style lang="scss" scoped>
    .bg-url {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .container-calendar-venue {
        border-radius: 20px;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        justify-content: flex-start;
        width: 75%;
    }
    .container-event-mode {
        border-radius: 20px;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        justify-content: flex-start;
        width: 70%;
        margin-bottom: 90px;
        margin-top: 150px;
    }
    .container-event-mode-creatine {
        border-radius: 20px;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
    }
    .registration-calendar {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 24px;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: #ffffff;
        margin-bottom: 0px;
    }
    .next-step-budget-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 20px;
        gap: 10px;
        min-width: 467px;
        background: #d7eb5a;
        border-radius: 100px;
        margin-top: 100px;
        border: none;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #1b0d29;
    }
    .back-step-budget-btn {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        color: #ffffff;
        margin-top: 18px;
    }
</style>
